import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("/home/ops/apps/spreadIt/app/layouts/app.vue").then(m => m.default || m)),
  "app-wide": defineAsyncComponent(() => import("/home/ops/apps/spreadIt/app/layouts/app_wide.vue").then(m => m.default || m)),
  "default-layout": defineAsyncComponent(() => import("/home/ops/apps/spreadIt/app/layouts/default_layout.vue").then(m => m.default || m)),
  island: defineAsyncComponent(() => import("/home/ops/apps/spreadIt/app/layouts/island.vue").then(m => m.default || m))
}